<div class="flex flex-row gap-3" [formGroup]="settingsForm">
  <div>
    <label class="block font-bold mb-2" for="complianceArea"
      >Compliance Area</label
    >
    <input
      inputId="complianceArea"
      type="text"
      pInputText
      class="w-full p-inputtext"
      formControlName="complianceArea"
    />
  </div>
</div>
